import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { load } from 'redux-load-api';
import _ from 'lodash';
import { AuthProvider, makeRouterRedirects } from './components/Auth';
import store from './redux/store';
import { clearAllMessages, clearAllErrors } from './redux/modules';
import { clearForms } from './redux/modules/form';
import { infoDismiss } from './redux/modules/info';
import { notifClearAll } from './redux/modules/notifs';
import App from './containers/App';
import ApiKeys from './containers/ApiKeys';
import Home from './containers/Home';
import NotFound from './containers/NotFound';
import OperationComplete from './containers/OperationComplete';

import 'react-datetime/css/react-datetime.css'; // eslint-disable-line import/first
import './index.css';

// Enchanced history
const history = syncHistoryWithStore(browserHistory, store);

const { userAuth } = makeRouterRedirects();

const onRouteChange = () => {
  store.dispatch(infoDismiss());
  store.dispatch(notifClearAll());
  store.dispatch(clearForms());
  store.dispatch(clearAllMessages());
  store.dispatch(clearAllErrors());

  window.scrollTo(0, 0);
  if (_.isFunction(_.get(window, 'parent.postMessage'))) {
    window.parent.postMessage('SCROLL_TOP', '*');
  }
};

// Pre-loads user authentication
load([App]);

// TODO: Use dash case for routes
ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <Router history={history}>
        <Route path="/" component={App} onChange={onRouteChange}>
          {/* Unauthenticated Routes */}
          <IndexRoute component={Home} />
          <Route path="operationComplete" component={OperationComplete} />

          {/* Authenticated Routes */}
          <Route path="api-keys" component={userAuth(ApiKeys)} />

          {/* Catch all route */}
          <Route path="*" component={NotFound} status={404} />
        </Route>
      </Router>
    </AuthProvider>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js